function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIcSendMessage = function SvgIcSendMessage(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "m4.891 4.458 12.992 6.599-12.992 6.447 1.9-6.447-1.9-6.599Z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "m2.75 5.043 1.764 5.916-1.77 5.961c-.344 1.163.297 2.391 1.433 2.745.545.169 1.134.11 1.636-.164l12.96-6.581c1.401-.77 1.405-3.02 0-3.882L5.818 2.459a2.125 2.125 0 0 0-2.909.906 2.246 2.246 0 0 0-.16 1.678ZM4.802 17.56l1.637-5.481 9.107.017L4.802 17.56ZM17.7 11l-2.155 1.096 2.155.004V11Zm-2.155-1.103h2.155V11l-2.155-1.103Zm0 0H6.44L4.806 4.4l10.74 5.497Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M15.257 9.9h2.932v2.2h-2.932z"
  }));
};
export default SvgIcSendMessage;